// extracted by mini-css-extract-plugin
module.exports = {"container":"NextTime_container__2CXbX","blockLabel":"NextTime_blockLabel__1B17Z","blockData":"NextTime_blockData__2QhU1"};